import React from 'react'
import { Typography, Divider, Grid } from '@material-ui/core'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import { RootState } from 'src/lib/store'

export const ConsumerInfo: React.FC = () => {
  const classes = useStyles()
  const payloadState = useSelector((state: RootState) => state.payload.data)

  return (
    <>
      <Typography variant='h6' className={classes.subTitle}>
        Consumer Information
      </Typography>
      <Divider />
      <Grid container className={classes.infoGroup}>
        <Grid item xs={6} className={classes.row}>
          <Typography>Name:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>
            {payloadState.consumerFirstName} {payloadState.consumerMiddleName ?? payloadState.consumerMiddleName} {payloadState.consumerLastName} {payloadState.consumerSuffix ?? payloadState.consumerSuffix}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>Address:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>
            {payloadState.consumerStreetAddress}
            <br />
            {payloadState.consumerAddressLine2 !== undefined ? <>{`${payloadState.consumerAddressLine2}`} <br /></> : null}
            {payloadState.consumerCity} {payloadState.consumerState} {payloadState.consumerZip}
            <br />
          </Typography>
        </Grid>
        {payloadState.consumerEmail &&
        <>
          <Grid item xs={6} className={classes.row}>
            <Typography>Email Address:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.row}>
            <Typography>{payloadState.consumerEmail}</Typography>
          </Grid>
        </>
        }
        <Grid item xs={6} className={classes.row}>
          <Typography>Phone Number:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>{payloadState.consumerPhoneNumber}</Typography>
        </Grid>
        {payloadState.consumerAccountNumber !== undefined && (
          <>
            <Grid item xs={6} className={classes.row}>
              <Typography>Account Number:</Typography>
            </Grid>
            <Grid item xs={6} className={classes.row}>
              <Typography>{payloadState.consumerAccountNumber}</Typography>
            </Grid>
          </>
        )}
        <Grid item xs={6} className={classes.row}>
          <Typography>Date of Birth:</Typography>
        </Grid>
        <Grid item xs={6} className={classes.row}>
          <Typography>{payloadState.consumerDateOfBirth}</Typography>
        </Grid>
      </Grid>
    </>
  )
}
